(async () => {

  if(!customElements.get('add-linked-product-to-cart')) {

    class AddLinkedProductToCart extends HTMLElement {
      constructor() {
        super();
        this.init();
      }

      init() {
        this.shopifyThemeVersion = 2;
        this.cartNotification = document.querySelector('cart-notification');
        this.cartItems = document.querySelector('cart-items');
        this.button = this.querySelector('[data-trigger]');
        this.button?.addEventListener('click', (event) => {
          this.addProduct(this.button.dataset.productVariantId, 1, this.button.dataset.availableQuantity);
        });
      }

      async addProduct(productVariantId, quantity = 1, availableQuantity) {
        
        // Stop when there is no variant id used
        if(!productVariantId) { return }

        try {

          // Enable load state
          this.button.classList.add('loading');
          this.cartItems.enableLoading();

          // Do the add to cart post
          const response = await fetch(`${routes.cart_add_url}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': `application/json` },
            body: JSON.stringify({
              items: [
                {
                  id: parseInt(productVariantId),
                  quantity: 1
                }
              ],
              sections: this.cartItems.getSectionsToRender().map((section) => section.section)
              })
            });

          const json_response = await response.json();
            
          // Check the response and out of stock error
          if(response.ok == false && response.status == 422 && availableQuantity) {
            this.cartNotification.renderQuantityError(availableQuantity);
          }
          
          if(json_response.errors) {
            throw new Error(json_response.errors);
          }

          // Reload the page for shopify 1.0 projects
          if(this.shopifyThemeVersion == 1) {
            window.location.reload();
            return;
          }

          // Refresh section with the cart-items component
          this.cartItems.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
  
            elementToReplace.innerHTML =
              this.cartItems.getSectionInnerHTML(json_response.sections[section.section], section.selector);
          }));

          this.button.classList.remove('loading');
          this.cartItems.disableLoading();
          
        } catch (error) {
          console.log(error);
          this.button.classList.remove('loading');
          this.cartItems.disableLoading();
        }
      }

    }

    window.AddLinkedProductToCart = AddLinkedProductToCart;

    customElements.define('add-linked-product-to-cart', AddLinkedProductToCart);

  }

})();